import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

export const createItemTraceabilityTemplateSheet = async (segments: string) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('Planilha')

  // Especificar as colunas onde queremos aplicar as validações
  const columnsWithValidation = ['C']

  // Adicionar validações a todas as células nas colunas especificadas
  columnsWithValidation.forEach((column) => {
    for (let i = 1; i <= 500; i++) {
      const cell = worksheet.getCell(`${column}${i}`)

      if (column === 'C' && i !== 1) {
        cell.dataValidation = {
          type: 'list',
          showErrorMessage: true,
          formulae: [`"${segments}"`],
        }
        cell.numFmt = '0'
      }

      cell.numFmt = '@'
    }
  })

  worksheet.columns = [
    {
      header: 'Nome Fornecedor',
      key: 'provider_name',
      width: 20,
    },
    {
      header: 'CNPJ / CPF Fornecedor',
      key: 'provider_tax_id',
      width: 20,
    },
    {
      header: 'Segmento Fornecedor',
      key: 'provider_segment',
      width: 20,
    },
    {
      header: 'País Fornecedor',
      key: 'provider_country',
      width: 20,
    },
    {
      header: 'Estado Fornecedor',
      key: 'provider_state',
      width: 20,
    },
    {
      header: 'Cidade Fornecedor',
      key: 'provider_city',
      width: 20,
    },
    {
      header: 'Rua Fornecedor',
      key: 'provider_street',
      width: 20,
    },
    {
      header: 'Numero do endereço Fornecedor',
      key: 'provider_number',
      width: 20,
    },
    {
      header: 'Email Fornecedor',
      key: 'provider_email',
      width: 20,
    },
    {
      header: 'Código Item',
      key: 'item_code',
      width: 20,
    },
    {
      header: 'Descrição Item',
      key: 'item_description',
      width: 20,
    },
    {
      header: 'Quantidade Item',
      key: 'item_quantity',
      width: 20,
    },
    {
      header: 'Unidade de medida Item (ex: m²)',
      key: 'item_tax_unit',
      width: 20,
    },
    {
      header: 'Numero GTA',
      key: 'transportation_data',
      width: 20,
    },
    {
      header: 'Numero do Brinco',
      key: 'cattle_data',
      width: 20,
    },
    {
      header: 'CAR',
      key: 'national_registry',
      width: 20,
    },
    {
      header: 'Dados de certificação do item',
      key: 'certification_data',
      width: 20,
    },

    {
      header: 'Código NF',
      key: 'invoice_code',
      width: 20,
    },

    {
      header: 'Chave de acesso NF ',
      key: 'invoice_acess_key',
      width: 20,
    },

    {
      header: 'Data de emissão NF',
      key: 'invoice_create_date',
      width: 20,
    },
  ]

  for (let i = 0; i < 500; i++) {
    const row = worksheet.addRow({
      provider_name: '',
      provider_tax_id: '',
      provider_segment: '',
      provider_country: '',
      provider_state: '',
      provider_city: '',
      provider_street: '',
      provider_number: '',
      provider_email: '',
      item_code: '',
      item_description: '',
      item_quantity: '',
      item_tax_unit: '',
      transportation_data: '',
      cattle_data: '',
      national_registry: '',
      certification_data: '',
      invoice_code: '',
      invoice_acess_key: '',
      invoice_create_date: '',
    })

    row.getCell('provider_name').numFmt = '@'
    row.getCell('provider_tax_id').numFmt = '@'
    row.getCell('provider_segment').numFmt = '@'
    row.getCell('provider_country').numFmt = '@'
    row.getCell('provider_state').numFmt = '@'
    row.getCell('provider_city').numFmt = '@'
    row.getCell('provider_street').numFmt = '@'
    row.getCell('provider_number').numFmt = '@'
    row.getCell('provider_email').numFmt = '@'
    row.getCell('item_code').numFmt = '@'
    row.getCell('item_description').numFmt = '@'
    row.getCell('item_quantity').numFmt = '@'
    row.getCell('item_tax_unit').numFmt = '@'
    row.getCell('transportation_data').numFmt = '@'
    row.getCell('cattle_data').numFmt = '@'
    row.getCell('national_registry').numFmt = '@'
    row.getCell('certification_data').numFmt = '@'
    row.getCell('invoice_code').numFmt = '@'
    row.getCell('invoice_acess_key').numFmt = '@'
    row.getCell('invoice_create_date').numFmt = '@'
  }

  // Salvar o arquivo do Excel
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    saveAs(blob, 'template_rastreabilidade.xlsx')
  })
}
